import React from 'react';
import { BaseDataGridToolbar } from '../../../components';
import { top149Api } from '../../../services';
import { useErrorHandler } from '../../../lib/errorHandler';

interface Top149ToolbarProps {
	searchValue?: string;
	onSearch?: (value: string) => void;
	onRefresh?: () => void;
	exportParams?: URLSearchParams;
	searchPlaceholder?: string;
	exportFunction?: (params: URLSearchParams) => Promise<void>;
	onExport?: () => Promise<void>;
	showExport?: boolean;
	isMobile?: boolean;
}

export const Top149Toolbar: React.FC<Top149ToolbarProps> = ({
	searchValue = '',
	onSearch,
	onRefresh,
	exportParams,
	searchPlaceholder = 'Tìm kiếm trường Top 149...',
	exportFunction,
	onExport,
	showExport = true,
	isMobile = false,
}) => {
	const { showError } = useErrorHandler();

	const defaultExportFunction = async (params: URLSearchParams) => {
		if (onExport) {
			await onExport();
			return;
		}
		try {
			await top149Api.exportToExcel(params);
		} catch (error) {
			console.error('[ERROR] Export Excel error:', error);
			showError('Có lỗi xảy ra khi tải xuống file Excel. Vui lòng thử lại.');
		}
	};

	return (
		<BaseDataGridToolbar
			searchValue={searchValue}
			onSearch={onSearch}
			onRefresh={onRefresh}
			exportFunction={exportFunction || defaultExportFunction}
			showExport={showExport}
			searchPlaceholder={searchPlaceholder}
			exportParams={exportParams}
			isMobile={isMobile}
		/>
	);
};